import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { IQuotation } from 'src/app/state/quotation/quotation.models';
import { environment } from 'src/environments/environment';
import { ICotizacionRequest } from '../../interfaces/request/ICotizacionRequest';
import { IRetarificarResponse } from '../../interfaces/response/IRetarificarResponse';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
import { ICotizacionPersona } from '../../interfaces/request/ICotizacionPersona.interface';


export interface queryGetCotizationList {
  idCotizacion?: number;
  UIDCotizacion?: number;
  idEntidad?: number;
  idCliente?: number;
  IdEstadoCotizacion?: number;
  EstadoAutorizacion?: string;
}

export interface IQuoteResponse {
  idCotizacion: number,
  anual: number
}

export interface IUpdateCotizacionBody {
  marca: string;
  modelo: string;
  numeroSerie?: string;
  numeroFactura?: string;
}

@Injectable({
  providedIn: 'root'
})
export class CotizacionService {

  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiPricing}`;
  url: string;


  constructor(private http: HttpClient) {
    this.url = this.baseUrl + this.apiUrl;
  }

  cotizar(body: ICotizacionRequest): Observable<IQuoteResponse> {
    return this.http.post<IHttpResponse<IQuoteResponse>>(`${this.url}/Quotation`, body)
    .pipe(
      map(result => {
        if (!result.succeeded) {
          console.error(result.errors);
          return null;
        } else {
          return result.data;
        }
      })
    );;
  }

  confirmarCotizacion(idCotizacion: number): Observable<any> {
    return this.http.post<any>(`${this.url}/ConfirmQuotation/${idCotizacion}`, {}).pipe(first());
  }

  generarViewCotizacion(idCotizacion: Number): Observable<any> {
    return this.http.get<any>(`${this.url}/GetViewQuotation/${idCotizacion}`, {});
  }

  getCotizacion(idCotizacion: Number): Observable<any> {
    return this.http.get<any>(`${this.url}/GetQuotation/${idCotizacion}`);
  }

  solicitarFotografia(idCotizacion): Observable<any> {
    return this.http.get<any>(`${this.url}/GetAskPhoto/${idCotizacion}`);
  }

  getPoliza(idPoliza): Observable<any> {
    return this.http.get<any>(`${this.url}/GetPolicy/${idPoliza}`);
  }

  getPolizaCustom(idPoliza): Observable<any> {
    return this.http.get<any>(`${this.url}/GetPolicyCustom/${idPoliza}`);
  }

  setCotizationForEmail(idCotizacion, serializedData): Observable<any> {

    const body = {
      idCotizacion: idCotizacion,
      serializedData: serializedData
    }

    return this.http.post<any>(`${this.url}/SetQuotationbyEmail`, body);
  }

  getCotizationMail(uuidCotizacion): Observable<any> {
    return this.http.get<any>(`${this.url}/GetQuotationEmail/${uuidCotizacion}/temp`);
  }

  retarificar(idCotizacion: number, numeroCarrito: number): Observable<IRetarificarResponse> {
    return this.http.post<IRetarificarResponse>(`${this.url}/ReQuotation/${idCotizacion}/${numeroCarrito}`, null);
  }


  getCotizationList( data?: queryGetCotizationList, proxy: boolean = false): Observable<IHttpResponse<IQuotation[]>> {
    let query;

    if(data){
      query = Object.keys(data)
        .map((key) => `${key}=${data[key]}`)
        .join('&');
    }

    let url = `${this.url}/GetQuotationList?${query}`;
    //if(proxy) url = `${environment.proxy.root}/${environment.proxy.api}/${this.apiUrl}/Cotizacion/GetV_Cotizaciones?${query}`;

    return this.http.get<IHttpResponse<IQuotation[]>>(url);
  }

  acceptCotizationLanding(cotizationId, proxy: boolean = false){

    let url = `${this.url}/GetAcceptQuotationLanding/${cotizationId}`;
    //if(proxy) url = `${environment.proxy.root}/${environment.proxy.api}/${this.apiUrl}/Cotizacion/${cotizationId}/update/Aceptada`;

    return this.http.post<any>(url, null);
  }

  updateCotizactionRiesgo(idCotizacion: number, idObjeto: number, body: IUpdateCotizacionBody) {
    return this.http.post<any>(`${this.url}/SetQuotationRisk/${idCotizacion}/${idObjeto}`, body);
  }

  updateCotizactionCliente(idCotizacion: number, idCliente: number) {
    return this.http.post<any>(`${this.url}/SetQuotationCustomer/${idCotizacion}/${idCliente}`, null);
  }

  /**
   * Endpoint que actualiza el idEntidad del procesor base. 
   */
   updateCotizacionIdEntidad(idCotizacion: number, idEntidad: number) {
     return this.http.post<any>(`${this.url}/SetQuotationEntity/${idCotizacion}/${idEntidad}`, null)
  }
 
  asociarCotizacionPersona(data: ICotizacionPersona, idCotizacion: number) {
    return this.http.post<any>(`${this.url}/Cotizacion/${idCotizacion}/cotizacionPersona`, data)

  }
}
